import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 4.75L8.65585 8.56956C8.45753 8.68775 8.23227 8.75 8.00293 8.75C7.77358 8.75 7.54832 8.68775 7.35 8.56956L1.5 4.75M2.8 2.75H13.2C13.918 2.75 14.5 3.33763 14.5 4.0625V11.9375C14.5 12.6624 13.918 13.25 13.2 13.25H2.8C2.08203 13.25 1.5 12.6624 1.5 11.9375V4.0625C1.5 3.33763 2.08203 2.75 2.8 2.75Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgMail;
